import React, { PureComponent } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import styles from "./DashboardChart.module.scss";
const noData = [{ name: "Group A", value: 400, fill: "#23fccf" }];
let chartsAssets = [
  { name: "dBTC", value: 12, fill: "#f8c624" },
  { name: "dETH", value: 20, fill: "#6b74b5" },
  { name: "dLINK", value: 100, fill: "#57e3fd" },
  { name: "dAAVE", value: 50, fill: "#bf2071" },
];
export default class DashboardChart extends PureComponent {
  render() {
    return (
      <div className={styles.wrapper}>
        <ResponsiveContainer width={200} height={200}>
          <PieChart onMouseEnter={this.onPieEnter}>
            {true ? (
              <Pie
                data={chartsAssets}
                innerRadius={94}
                outerRadius={100}
                stroke="transparent"
                paddingAngle={3}
                dataKey="value"
                fill="#fff"
              />
            ) : (
              <Pie
                data={noData}
                innerRadius={85}
                outerRadius={100}
                stroke="transparent"
                paddingAngle={5}
                dataKey="value"
                fill="#fff"
              />
            )}
          </PieChart>
        </ResponsiveContainer>
        <div className={styles.portfolioInfo}>
          <div className={styles.totalAssets}>Estimated Balance</div>
          <div className={styles.totalWorth}>$ 60,231</div>
          <div className={styles.totalAssets}>dAsset Value</div>
        </div>
      </div>
    );
  }
}
